import { Component, Input } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { NavServiceService } from 'src/app/services/nav-service.service';
import { BreadcrumbService } from './breadcrumb.service';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent {

  @Input() menuList: any[] = [];
  breadcrumbList: any[] = [];
  displayMenu: boolean = true;

  private destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public navService: NavServiceService,
    private breadcrumbService: BreadcrumbService
  ){}

  ngOnInit(){
    this.updateBreadcrumb();

    this.router.events.pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
    ).subscribe((res) => {
        this.breadcrumbList = this.buildBreadcrumb(this.activatedRoute.root);
        this.updateMenu();
    });

  }

  ngOnDestroy(){
    this.destroy$.next();
    this.destroy$.complete();
  }

  private updateBreadcrumb() {
    this.breadcrumbList = this.buildBreadcrumb(this.activatedRoute.root);
        this.updateMenu();
  }

  buildBreadcrumb( route: ActivatedRoute, url: string = '', breadcrumbs: any[] = [] ): any[] {
    const children = route.children;

    if (!children.length) {
        return breadcrumbs;
    }
    
    let i=0;

    for (const child of children) {

        const routeURL = child.snapshot.url
            .map(segment => segment.path)
            .join('/');

        if (routeURL) {
            url += `/${routeURL}`;
        }

        const label = child.snapshot.data['breadcrumb'];

        if (Array.isArray(label)) {
          breadcrumbs.push(...label);
        } else if (label) {
          let item = i === (children.length - 1) ? { label } : { label, routerLink: [url] };
          breadcrumbs.push(item);
        }

        i++;

        return this.buildBreadcrumb(child, url, breadcrumbs);
    }

    return breadcrumbs;
  }

  updateMenu(){
    let route = this.activatedRoute;

    while (route.firstChild) {
      route = route.firstChild;
    }

    this.displayMenu = route.snapshot.data['displaySubMenu'];
    if (this.displayMenu){
      let getKey = route.snapshot.data['submenu_key'];
      this.menuList = this.breadcrumbService.getMenu(getKey);
    }

  }

  navigateTo(item: any){
    this.navService.NavigateRoute(item?.parentLink, item?.routerLink);
  }
}
